module.exports = __webpack_public_path__ + "media/images/85/circadian_rhytm_mimosa_pudica-87a7664f140ca6fe8174956d6751bdb4.webp";